import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const OFFICES = [
  {
    id: "ontario", city: "Ontario", state: "CA", label: "Ontario, CA", tag: "Corporate HQ",
    address: "3595 Inland Empire Blvd., Ste 1100, Ontario, CA 91764",
    phone: "(909) 505-8015", hours: "Monday–Friday · 8am–5pm",
    blurb: "Our corporate office and the heart of HR staffing in Ontario, CA. A leading agency across the Inland Empire, we provide job placement, recruitment, payroll services and PEO solutions for Southern California businesses and job seekers.",
  },
  {
    id: "chino-hills", city: "Chino Hills", state: "CA", label: "Chino Hills, CA", tag: "Branch",
    address: "12469 Central Ave., Chino, CA 91710",
    phone: "(909) 353-2344", hours: "Monday–Friday · 8am–5pm",
    blurb: "HR staffing in Chino, CA. A leading staffing agency in Chino Hills, we offer recruitment, payroll services and PEO solutions for local businesses and job seekers.",
  },
  {
    id: "fontana", city: "Fontana", state: "CA", label: "Fontana, CA", tag: "Branch",
    address: "9765 Sierra Ave, Suite G, Fontana, CA 92335",
    phone: "(909) 466-6090", hours: "Monday–Friday · 8am–5pm",
    blurb: "A top staffing agency in Fontana, CA, delivering customized recruitment, payroll services and PEO solutions that help local businesses thrive and job seekers secure rewarding careers.",
  },
  {
    id: "commerce", city: "Commerce", state: "CA", label: "Commerce, CA", tag: "Branch",
    address: "5900 S. Eastern Ave. Suite 119, Commerce, CA 90064",
    phone: "(626) 474-2462", hours: "Monday–Friday · 8am–5pm",
    blurb: "A leading staffing agency in Commerce, CA, providing expert recruitment, payroll services and PEO solutions — connecting local businesses with top talent and job seekers with fulfilling opportunities.",
  },
  {
    id: "moreno-valley", city: "Moreno Valley", state: "CA", label: "Moreno Valley, CA", tag: "Branch",
    address: "24757 Alessandro Blvd, Suite 6, Moreno Valley, CA 92553",
    phone: "(909) 618-1338", hours: "Monday–Friday · 8am–5pm",
    blurb: "A leading staffing agency in Moreno Valley, CA, providing expert recruitment, payroll services and PEO solutions — empowering local businesses with talent and job seekers with career opportunities.",
  },
  {
    id: "perth-amboy", city: "Perth Amboy", state: "NJ", label: "Perth Amboy, NJ", tag: "Branch",
    address: "301 Oak Street, Perth Amboy, NJ 08861",
    phone: "(732) 836-0642", hours: "Monday–Friday · 8am–5pm",
    blurb: "A leading staffing agency in Perth Amboy, NJ, offering expert recruitment, payroll services and PEO solutions — connecting local businesses with skilled talent and job seekers with meaningful careers.",
  },
];

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
];

export const SERVICES = [
  { n: "01", title: "HR Staffing", desc: "Temporary, temp-to-hire and permanent talent placed fast — from contract labor to skilled direct placement across Southern California." },
  { n: "02", title: "Payroll Services", desc: "Seamless, compliant payroll processing that saves you time and resources while keeping your workforce paid accurately and on schedule." },
  { n: "03", title: "PEO Solutions", desc: "Comprehensive HR administration, benefits and compliance support so you can focus on running and growing your business." },
  { n: "04", title: "Recruiting & RPO", desc: "Customized Recruitment Process Outsourcing and expert recruiters who source, screen and vet the right people for your roles." },
  { n: "05", title: "Direct Placement", desc: "Permanent hires built on deep vetting, culture-fit and long-term retention." },
  { n: "06", title: "On-Site Management", desc: "Dedicated on-site managers embedded with high-volume accounts, owned end to end." },
];

export const INDUSTRIES = [
  "Administrative", "Logistics", "Hospitality", "Industrial", "Clerical",
  "Technical", "Manufacturing", "Distribution", "Health Care",
];

export const TEAM = [
  { slug: "gabriela", name: "Gabriela Mendoza", title: "CEO & President" },
  { slug: "rocio", name: "Rocio Ramos", title: "General Manager" },
  { slug: "felipe", name: "Felipe Soltero", title: "Regional On-site Manager" },
  { slug: "laura", name: "Laura Soto", title: "Compliance Manager" },
  { slug: "aaron", name: "Aaron Ramos", title: "Safety Manager" },
  { slug: "cesar", name: "Cesar Madrigal", title: "Safety Supervisor" },
  { slug: "adriana", name: "Adriana Rodriguez", title: "Senior Recruiter" },
];

export const COMPANY = {
  phone: "(909) 505-8015",
  phoneHref: "tel:+19095058015",
  corporate: "3595 Inland Empire Blvd., Ste 1100, Ontario, CA 91764",
  regions: "Los Angeles · Orange County · Inland Empire",
  socials: {
    facebook: "https://www.facebook.com/HRDirectChino",
    youtube: "https://www.youtube.com/channel/UCDuSVDLvYQPfAmeo-YwJubQ",
    linkedin: "https://www.linkedin.com/company/hr-direct-services/",
    instagram: "https://www.instagram.com/hrdirectservicesinc/",
  },
  eeo: "HR Direct is an Affirmative Action and Equal Opportunity Employer. HR Direct prohibits discrimination and harassment and provides consideration of employment to all individuals without regard to race, color, religion, age, sex, national origin, disability status, genetics, protected veteran status, sexual orientation, gender identity or expression, or any other characteristic protected by federal, state or local laws for all employees and applicants.",
};

export const SMS_CONSENT_TEXT_YES =
  "Yes, I authorize Avionté on behalf of HR Direct Services Inc, The GHR Company, and The GHR Management Co. to send SMS text messages about current, future, or past employment (such as openings, offers, opportunities, confirmations, questions, and reminders) using an automatic dialing system. If I do not wish to receive SMS text messages, I can unsubscribe by Opting-Out from the Talent Portal/Onboarding Task or responding to a text with STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT. I understand standard text messaging rates and fees from my mobile carrier may apply and message frequency may vary.";

export const SMS_CONSENT_TEXT_NO =
  "No, I do not authorize Avionté on behalf of HR Direct Services Inc, The GHR Company, and The GHR Management Co. to send SMS text messages about current, future, or past employment (such as openings, offers, opportunities, confirmations, questions, and reminders) using an automatic dialing system.";
